module.exports = __webpack_public_path__ + "static/TOP_desk-ba37d01169a8ffce150647404aa0f8d4.svg";